export default function ErrorComponent({
  title = "Oh, dear. Something went wrong.",
  text = "I'll try to fix this ASAP.",
  children,
}) {
  return (
    <div className="flex flex-col items-center content-center justify-center space-y-4">
      <svg
        enableBackground="new 0 0 64 64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        className="w-32 h-32"
      >
        <g id="error-icon">
          <g>
            <g>
              <g>
                <path
                  d="m6 54h52c1.105 0 2-.895 2-2v-36c0-1.105-.895-2-2-2h-52c-1.105 0-2 .895-2 2v36c0 1.105.895 2 2 2z"
                  fill="#0a5078"
                />
              </g>
              <g>
                <path
                  d="m9 50h46c.552 0 1-.448 1-1v-30c0-.552-.448-1-1-1h-46c-.552 0-1 .448-1 1v30c0 .552.448 1 1 1z"
                  fill="#00a0c8"
                />
              </g>
              <g>
                <path
                  d="m55 18h-18.958c.508 6.159 5.667 11 11.958 11 3.074 0 5.877-1.156 8-3.057v-6.943c0-.552-.448-1-1-1z"
                  fill="#0082aa"
                />
              </g>
              <g>
                <path
                  d="m28 54h8v4h-8z"
                  fill="#0a5078"
                  transform="matrix(-1 0 0 -1 64 112)"
                />
              </g>
              <g>
                <path
                  d="m20 60h24c0-1.105-.895-2-2-2h-20c-1.105 0-2 .895-2 2z"
                  fill="#0a5078"
                />
              </g>
              <g>
                <path
                  d="m28 54h8v1h-8z"
                  fill="#00325a"
                  transform="matrix(-1 0 0 -1 64 109)"
                />
              </g>
            </g>
            <g>
              <circle cx="32" cy="35" fill="#0082aa" r="14" />
            </g>
            <g>
              <g>
                <circle cx="32" cy="34" fill="#f0f0f0" r="14" />
              </g>
              <g>
                <path
                  d="m44.921 28.6c-1.527-3.65-4.556-6.516-8.314-7.825 1.265 3.82 4.396 6.788 8.314 7.825z"
                  fill="#d2d2d2"
                />
              </g>
              <g fill="#0a5078">
                <path d="m27 32.414 1.293 1.293c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414l-1.293-1.293 1.293-1.293c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-1.293 1.293-1.293-1.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l1.293 1.293-1.293 1.293c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293z" />
                <path d="m38.414 31 1.293-1.293c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-1.293 1.293-1.293-1.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l1.293 1.293-1.293 1.293c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293l1.293-1.293 1.293 1.293c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414z" />
                <path d="m32 37c-4.565 0-6.802 4.367-6.895 4.553-.246.493-.047 1.091.445 1.339.491.248 1.094.051 1.342-.441.018-.036 1.792-3.451 5.108-3.451s5.09 3.415 5.105 3.447c.176.351.529.553.896.553.15 0 .303-.034.446-.105.494-.247.694-.848.447-1.342-.092-.186-2.329-4.553-6.894-4.553z" />
              </g>
            </g>
            <g>
              <circle cx="48" cy="16" fill="#c80a50" r="12" />
            </g>
            <path
              d="m49.414 16 4.293-4.293c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-4.293 4.293-4.293-4.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l4.293 4.293-4.293 4.293c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293l4.293-4.293 4.293 4.293c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414z"
              fill="#f0f0f0"
            />
          </g>
        </g>
      </svg>
      <div className="text-center">
        {children || (
          <>
            <h3 className="text-3xl">{title}</h3>
            <p className="text-2xl">{text}</p>
          </>
        )}
      </div>
    </div>
  );
}
